import './activity-modal.css'

import React, { useState, useEffect } from 'react'
import Modal from 'react-bootstrap/Modal'

import { GroupOffers } from '../../../common/components/GroupOffers'
import User from '../../../dtos/User'
import { IActivity, ICalendarGroup } from '../types'

interface IActivityModalProps {
  user: Partial<User> | null
  isOpened: boolean
  onClose: () => void
  goToLogin: () => void
  activity: IActivity | undefined
  group: ICalendarGroup | undefined
  shopUrl: string | undefined
  organizationSlug: string | undefined
}

export const ActivityModal: React.FC<IActivityModalProps> = ({
  isOpened,
  onClose,
  activity,
  group,
  ...groupOffersProps
}) => {

    useEffect(() => {
        if (isOpened && group) {
            const modal = document.getElementById('activity-modal-' + group.id);
            if (modal) {

                window.scrollTo({
                    top: modal.offsetHeight,
                    behavior: 'smooth'
                });
            }
        }
    }, [isOpened]);

    const styleClasses = (
        group && activity && [
            `group-${group.id}`,
            ...activity.categories.map(({id}) => `category-${id}`),
            `program-${group.programmation_id}`,
            `activity-${activity.id}`
        ]
    ) || [];

  return (
    <>
      {activity && group && (
          <Modal
              id={"activity-modal-" + group.id}
              contentClassName={styleClasses.join(" ")}
              show={isOpened}
              onHide={onClose}
              backdrop="static"
              dialogClassName="modal-dialog_activity "
              centered>
          <GroupOffers
            onContinueShopping={onClose}
            activity={activity}
            group={group}
            shouldRedirectToLogin={false}
            {...groupOffersProps}
          />
        </Modal>
      )}
    </>
  )
}
